module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Polygon-c533d1ec8c4def96f93bbba0ce1005cf.svg";